import React, { Component, PureComponent } from "react";
import "./ServiceReport.css";
import { connect } from "react-redux";
import NavigatorMain from "../NavigatorMain";

import { getServiceReportList, getServiceReportListHasQuarterly, serviceReporListDel } from "../../action/ServiceReportAction";
import NHeader from "../NHeader.js";
import { hashHistory } from "react-router";

class ServiceReport extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    let { dispatch } = this.props;
    const param = {
      superFundCode: this.props.location.state.superFundCode, 
      pageNum: 1,
      pageSize: 10,
    };
    this.props.location.state.hasQuarterly ? dispatch(getServiceReportListHasQuarterly(param)) : dispatch(getServiceReportList(param));
    document.title = '投顾服务报告'
  }
  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(serviceReporListDel());
  }

  getMore() {
    let { dispatch, serviceReportList } = this.props;
    if (serviceReportList.total === serviceReportList.data.length) return;
    const param = {
      superFundCode: this.props.location.state.superFundCode,
      pageNum: serviceReportList.pageNum + 1,
      pageSize: 10,
    };
    dispatch(getServiceReportList(param));
  }
  goBack() {
    hashHistory.goBack();
  }
  render() {
    const { serviceReportList } = this.props;
    return (
      <div className="container SR_wrap" style={{ display: "flex", maxHeight: document.documentElement.clientHeight /*  window.screen.height */ }}>
        <NavigatorMain>
          <NHeader title="投顾服务报告" isPaddingBottom={0} />
        </NavigatorMain>
        <div className="SR_con_wrap">
          <div className="SR_content">
            {this.props.location.state.hasQuarterly&&<div className="SR_data">
              <p>
                Hi，已为您服务<span className="SR_days">{this.props.location.state.serveDays}</span>天
              </p>
            </div>}
            <ScrollView moreEvent={this.getMore.bind(this)}>
              <div className="SR_list" style={{}}>
                {Object.entries(serviceReportList.processData).map((item) => (
                  <ItemList token={this.props.location.state.token} date={item[0]} dataList={item[1]} key={item[0]} />
                ))}
              </div>
            </ScrollView>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    serviceReportList: state.serviceReportReducer.serviceReportList,
  };
}

export default connect(mapStateToProps)(ServiceReport);

class Item extends Component {
  toRecentNewsDetail = (v) => {
    console.log(v);
    if(v.monthReportToPortal && this.props.token) {
      const fundCode = v.monthReportToPortal.monthReportTemplate.fundCode;
      const year = v.monthReportToPortal.monthReportTemplate.year;
      const month = v.monthReportToPortal.monthReportTemplate.month;
      const token = this.props.token;
      const _url = year > 2020 ? "NewQuarterlyReport/index.html?device=h5&token=" : "QuarterlyReport/index.html?device=h5&token="
      const _urlSec = _url + token + "&fundCode=" + fundCode + "&month=" + month + "&year=" +  year;
      // window.open("http://10.16.160.74/monthReport/" + _urlSec); //测试
      window.open("https://app.amcfortune.com/wAppStatic/" + _urlSec); //生产
    }else {
      hashHistory.push({
        pathname: "/ServiceReportDetail",
        state: { id:v.id },
        query: { id:v.id },
      });
    }
  };
  render() {
    const { data } = this.props;
    const type = ["投顾服务报告", "投顾服务报告", "投顾季报"];
    const intro = [<div className="SR_item_intro">{data.overView}</div>];
    return (
      <div className="SR_item_con" onClick={() => {this.toRecentNewsDetail(data)}}>
        <div className="SR_item_tip">
          <span>{type[data.type]}</span>
          <span>{data.newsTime}</span>
        </div>
        <div className="SR_item_title">{data.title}</div>
        {intro[0]}
      </div>
    );
  }
}

class ItemList extends Component {
  render() {
    const { dataList, date } = this.props;
    const lineHeight = this.props.dataList.length * 1.94 + this.props.dataList.length * 0.2 + "rem";
    const month = parseInt(date.slice(5, 7));
    const day = date.slice(8);
    return (
      <div className="RS_Item" style={{ marginTop: "-.1rem" }}>
        <div className="Item_data">
          <span className="Item_data_day">{day}</span>
          <span className="Item_data_m">{month}月</span>
        </div>
        <div className="Item_line">
          <div className="Item_line_circle"></div>
          <div className="Item_line_line" style={{ height: lineHeight }}></div>
        </div>
        <div className="SR_item_list" style={{ marginTop: "-.18rem" }}>
          {dataList.map((item, index) => (
            <Item token={this.props.token} data={item} key={item.id} />
          ))}
        </div>
      </div>
    );
  }
}

class ScrollView extends PureComponent {
  componentDidMount() {
    const node = document.querySelector("#scroll");
    node.addEventListener("scroll", () => {
      const scrollBottom = node.scrollHeight - node.scrollTop - node.clientHeight;
      console.log(document.documentElement.scrollTop); //代表目前滚动条和最上方的距离多长
      console.log(document.documentElement.scrollHeight); //代表整个滚动条多长
      console.log(document.documentElement.clientHeight);
      console.log("-----", scrollBottom, node.scrollHeight, node.scrollTop, node.clientHeight);
      if (scrollBottom < 0.5) this.props.moreEvent();
    });
  }
  render() {
    return (
      <div id="scroll" style={{ height: "auto", overflowY: "scroll" }}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/fundDetail/ServiceReport.js